import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AbstractJastVisitor } from '@atlaskit/jql-ast';
import { JQLEditorSchema } from '../../../schema';
import getDocumentPosition from '../../common/get-document-position';
import { getJastFromState } from '../../jql-ast';
import { RICH_INLINE_NODE } from '../constants';
export var replaceRichInlineNodes = function replaceRichInlineNodes(editorState, hydratedValues) {
  var ast = getJastFromState(editorState);
  var transaction = editorState.tr;
  // Do not allow users to revert this transaction with undo command so they can't land in an unhydrated state
  transaction.setMeta('addToHistory', false);
  Object.entries(hydratedValues).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      fieldName = _ref2[0],
      values = _ref2[1];
    values.forEach(function (value) {
      if (value.type === 'user') {
        var astNodes = getValueNodes(ast, fieldName, value.id);
        astNodes.forEach(function (astNode) {
          if (astNode.position) {
            var _astNode$position = _slicedToArray(astNode.position, 2),
              from = _astNode$position[0],
              to = _astNode$position[1];
            var documentFrom = getDocumentPosition(transaction.doc, from);
            if (!isRichInlineNode(transaction.doc, documentFrom)) {
              var documentTo = getDocumentPosition(transaction.doc, to);
              var node = getRichInlineNode(fieldName, value, astNode.text);
              transaction.replaceWith(documentFrom, documentTo, node);
            }
          }
        });
      }
    });
  });
  return transaction;
};
var getRichInlineNode = function getRichInlineNode(fieldName, value, text) {
  switch (value.type) {
    case 'user':
      {
        var textContent = JQLEditorSchema.text(text);
        return JQLEditorSchema.nodes.user.create(_objectSpread(_objectSpread({}, value), {}, {
          fieldName: fieldName
        }), textContent);
      }
    default:
      {
        throw new Error("Unsupported hydrated value type ".concat(value.type));
      }
  }
};
var isRichInlineNode = function isRichInlineNode(doc, position) {
  var _doc$resolve$nodeAfte;
  return ((_doc$resolve$nodeAfte = doc.resolve(position).nodeAfter) === null || _doc$resolve$nodeAfte === void 0 ? void 0 : _doc$resolve$nodeAfte.type.spec.group) === RICH_INLINE_NODE;
};
var getValueNodes = function getValueNodes(ast, field, value) {
  if (!ast.query) {
    return [];
  }
  return ast.query.accept(new FindValuesVisitor(field, value));
};
var FindValuesVisitor = /*#__PURE__*/function (_AbstractJastVisitor) {
  function FindValuesVisitor(field, value) {
    var _this;
    _classCallCheck(this, FindValuesVisitor);
    _this = _callSuper(this, FindValuesVisitor);
    _defineProperty(_this, "visitQuery", function (query) {
      if (query.where === undefined) {
        return [];
      }
      return query.where.accept(_this);
    });
    _defineProperty(_this, "visitCompoundClause", function (compoundClause) {
      return compoundClause.clauses.reduce(function (operands, compoundClause) {
        return [].concat(_toConsumableArray(operands), _toConsumableArray(compoundClause.accept(_this)));
      }, []);
    });
    _defineProperty(_this, "visitTerminalClause", function (terminalClause) {
      if (terminalClause.field.value !== _this.field) {
        return [];
      }
      if (terminalClause.operand === undefined) {
        return [];
      }
      return terminalClause.operand.accept(_this);
    });
    _defineProperty(_this, "visitNotClause", function (notClause) {
      return notClause.clause.accept(_this);
    });
    _defineProperty(_this, "visitValueOperand", function (valueOperand) {
      if (valueOperand.value !== _this.value) {
        return [];
      }
      return [valueOperand];
    });
    _defineProperty(_this, "visitListOperand", function (listOperand) {
      return listOperand.values.reduce(function (values, operand) {
        return [].concat(_toConsumableArray(values), _toConsumableArray(operand.accept(_this)));
      }, []);
    });
    _this.field = field;
    _this.value = value;
    return _this;
  }
  _inherits(FindValuesVisitor, _AbstractJastVisitor);
  return _createClass(FindValuesVisitor, [{
    key: "aggregateResult",
    value: function aggregateResult(aggregate, nextResult) {
      return [].concat(_toConsumableArray(aggregate), _toConsumableArray(nextResult));
    }
  }, {
    key: "defaultResult",
    value: function defaultResult() {
      return [];
    }
  }]);
}(AbstractJastVisitor);